import { useEffect, useRef } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { EXPERIENCE_NAME_PREFIX } from '../experience-tracker/ExperienceNames';
import { createExperienceTrackerAnalyticsEventPayload } from './createExperienceTrackerAnalyticsEventPayload';
import { ANALYTICS_CHANNEL } from './index';
export var useAnalytics = function useAnalytics(experienceTracker) {
  var unsubscribeRef = useRef();
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  if (!unsubscribeRef.current && experienceTracker) {
    unsubscribeRef.current = experienceTracker.subscribe(function (event) {
      if (event.name.startsWith(EXPERIENCE_NAME_PREFIX)) {
        // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent(createExperienceTrackerAnalyticsEventPayload(event)).fire(ANALYTICS_CHANNEL);
      }
    });
  }
  useEffect(function () {
    return unsubscribeRef.current;
  }, []);
};